import { useCallback, useState } from 'react';
import axios, { AxiosError } from 'axios';
import getOmsUrl from '@utils/getOmsUrl';
import { sentryCaptureException } from '@utils/sentry';
import { useAccountStore } from '../context/UserDashboardContext';

const useHealthProfile = (): {
  errorGetProfile: string | undefined;
  loadingGetProfile: boolean;
  getProfile: (googleIdToke: string) => void;
} => {
  const [errorGetProfile, setErrorGetProfile] = useState<string>();
  const [loadingGetProfile, setLoadingGetProfile] = useState(false);
  const setHealthProfile = useAccountStore((accountState) => accountState.setHealthProfile);
  const setHealthProfileLoaded = useAccountStore((accountState) => accountState.setHealthProfileLoaded);
  const getProfile = useCallback(async (googleIdToken: string) => {
    setHealthProfileLoaded(false);
    const omsUrl = getOmsUrl();
    const url = `${omsUrl}/health/profile`;

    const headers = {
      token: googleIdToken ?? '',
      'Content-Type': 'application/json'
    };

    setLoadingGetProfile(true);

    try {
      const res = await axios.get(url, { headers });
      setLoadingGetProfile(false);
      setHealthProfile(res.data);
    } catch (err) {
      let errorData;
      if (axios.isAxiosError(err)) {
        const axiosError = err as AxiosError;
        errorData = {
          message: axiosError.message,
          code: axiosError.code,
          status: axiosError.response?.status,
          statusText: axiosError.response?.statusText,
          url: axiosError.config?.url,
          method: axiosError.config?.method,
          responseData: axiosError.response?.data
        };
      }
      sentryCaptureException(err, { tags: { failed: 'getHealthProfile' }, ...(errorData && { extra: { axiosError: errorData } }) });
      setErrorGetProfile((err as Error).message);
      setLoadingGetProfile(false);
    } finally {
      setHealthProfileLoaded(true);
    }
  }, []);

  return { errorGetProfile, loadingGetProfile, getProfile };
};

export default useHealthProfile;
